/* Career Hero Section JavaScript */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    // Get all career-hero sections on the page
    const sections = document.querySelectorAll('[id^="shopify-section-"]');
    
    sections.forEach(function(section) {
      const heroActions = section.querySelector('.career-hero-actions');
      if (!heroActions) return;

      heroActions.addEventListener('click', function(e) {
        const btn = e.target.closest('.career-hero-btn');
        if (!btn) return;

        const href = btn.getAttribute('href');
        if (href && href.startsWith('#')) {
          const target = document.querySelector(href);
          if (target) {
            e.preventDefault();
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
            // Update URL without refresh
            history.pushState(null, null, href);
          }
        }
      });
    });
  });
})();
